import { compareFilterSpec } from '@ow/utils'

export { compareFilterSpec as filterSpec }

export const config = {
  hint: '请输入',
  slug: `number${Math.round(Math.random() * 100)}`,
  type: 'number',
  title: '数值',
  intro: null,
  readonly: false,
  required: false,
  description: null,
  defaultValue: null,
  // 显示类型：thousandSeparator显示千位分隔符 percent：是否显示百分比
  showType: '',
  rangeSetting: false,
  max: null,
  min: null,
  // 小数位数
  decimalDigits: null,
  unit: null,
  // render 有 slider 和 input 两种, slider 为多行滑动输入, input 为数字输入
  render: 'input',
}
